import React, { useState, useEffect, useCallback, useContext } from "react";
import { Formik, Form, Field } from "formik";
import { EmployeeNavbar } from "../reusedcomponent/navbar";
import { ApiService } from "../../../../services/ApiService";
import { useAlert } from "react-alert";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { useHistory, Link } from "react-router-dom";
import { AuthContext } from "../../../../Context/AuthContext";
import "filepond/dist/filepond.min.css";
import moment from "moment";
import { employeeMngtThunk } from "../../../../store/actions/employeemanagement/employee.thunk";
import { useDispatch, useSelector } from "react-redux";
import { useLoadingMessage } from "../../../../components/useLoadingMessage";
import { PageBody } from "../../../../components/loader";
import { FilePond, registerPlugin } from "react-filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import { constant } from "../../../../Constants/constant";
import axios from "axios";
import { Users } from "react-feather";

registerPlugin(FilePondPluginFileValidateType);

export default function EditUser({ match }) {
  const { user } = useContext(AuthContext);
  const alert = useAlert();
  const history = useHistory();
  const { isLoading, message, updateLoader } = useLoadingMessage();
  const { employee, roles, banks, remaining, leaves, jobtitles, days } =
    useSelector((state) => state.employeeMngt);
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);

  const [image, setImage] = React.useState({});
  const [show, setShow] = React.useState();
  const [files, setFiles] = useState([]);

  // const image = useRef(null);

  const getEmployeeDetails = useCallback(async () => {
    updateLoader(true, "Getting employee");
    await dispatch(employeeMngtThunk.getEmployee(match.params.slug));
    updateLoader(false);
  }, [dispatch]);

  const upload = (e) => {
    e.preventDefault();
    // let base64String = "";
    // var reader = new FileReader();
    // reader.onload = function () {
    //   base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
    // };
    // reader.readAsDataURL(image);
    // console.log("base64", base64String);

    // console.log("filesss", image);

    let formData = new FormData();
    formData.append("file", image);

    const token = localStorage.getItem("token");

    const headers = {
      // "Content-Type": "application/json",
      "Content-Type": "multipart/form-data",
    };

    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    axios({
      method: "post",
      url: `${constant.HttpURL}users/upload-profile-picture/${employee.slug}`,
      data: formData,
      headers: headers,
    })
      .then(function (response) {
        alert.success(response.data.msg);
      })
      .catch(function (response) {
        //handle error
        console.log(response);
      });
  };

  const handleUpload = (e) => {
    let file = e.target.files[0];
    setImage(file);
  };

  useEffect(() => {
    getEmployeeDetails();
  }, []);

  const optionsss = [];

  roles.map((role) => optionsss.push({ value: role.id, label: role.name }));

  return (
    <React.Fragment>
      <PageBody isLoading={isLoading} message={message}>
        <EmployeeNavbar />
        <div className="content">
          <div className="col-12">
            <div class="col-md-12">
              <h4 style={{ color: "#000" }}>Personal Details</h4>
            </div>
            {loader ? (
              <div className="text-center m-auto">
                <div
                  className="spinner-border spinner-border-xl text-success"
                  role="status"
                >
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : (
              <Formik
                initialValues={{
                  first_name: employee.first_name,
                  middle_name: employee.middle_name,
                  last_name: employee.last_name,
                  email: employee.email,
                  // date_of_employment: moment(employee.date_of_employment).format(
                  //   "YYYY-MM-DD"
                  // ),
                  date_of_employment: new Date(employee.date_of_employment),
                  employee_number: employee.employee_number,
                  gender: employee.gender,
                  preferred_name: employee.preferred_name,
                  // date_of_birth: moment(employee.date_of_birth).format(
                  //   "YYYY-MM-DD"
                  // ),
                  date_of_birth:
                    employee.date_of_birth !== null
                      ? new Date(employee.date_of_birth)
                      : null,
                  mobile_number: employee.mobile_number,
                  office: employee.office,
                  role: employee.roles
                    ? [{ value: employee.roles.id, label: employee.roles.name }]
                    : employee.additional_role && [
                        {
                          value: employee.roles.id,
                          label: employee.roles.name,
                        },
                        {
                          value: employee.additional_role.id,
                          label: employee.additional_role.name,
                        },
                      ],
                  job_title: employee.job_title && employee.job_title.id,
                  full_name:
                    employee.next_of_kins && employee.next_of_kins.length > 0
                      ? employee.next_of_kins[0].full_name
                      : null,
                  phonenumber:
                    employee.next_of_kins && employee.next_of_kins.length > 0
                      ? employee.next_of_kins[0].phonenumber
                      : "",
                  next_of_kin_address:
                    employee.next_of_kins && employee.next_of_kins.length > 0
                      ? employee.next_of_kins[0].address
                      : "",
                  relationship:
                    employee.next_of_kins && employee.next_of_kins.length > 0
                      ? employee.next_of_kins[0].relationship
                      : "",
                  account_number:
                    employee.account_details &&
                    employee.account_details.length > 0
                      ? employee.account_details[0].account_number
                      : "",
                  bank_name:
                    employee.account_details &&
                    employee.account_details.length > 0
                      ? employee.account_details[0].bank_name
                      : "",
                  user_id: employee.id,
                  slug: employee.slug,
                }}
                onSubmit={(values) => {
                  values.date_of_employment = new Date( values.date_of_employment.getTime() + Math.abs(values.date_of_employment.getTimezoneOffset()*60000));
                  ApiService.post(
                    `users/update-user/${employee.slug}`,
                    values
                  ).then((res) => {
                    if (res.data.type === false) {
                      alert.error(res.data.msg);
                    } else if (res.data.type === true) {
                      alert.success(res.data.msg);
                      history.push("/dashboard/employee");
                    }
                  });
                }}
              >
                {({ handleSubmit, values, isSubmitting, setFieldValue }) => (
                  <React.Fragment>
                    <div className="row mx-auto">
                      <div className="col-md-12">
                        <div className="form-icon">
                          <span>
                            <img
                              height="80px"
                              width="80px"
                              src={`${constant.ImgURL}/storage/profile_pictures/uploads/${employee.profile_picture}`}
                              className="rounded-circle"
                              // alt="profile"
                            />
                          </span>
                        </div>
                        <form onSubmit={upload} className="text-center">
                          <input
                            type="file"
                            onChange={handleUpload}
                            className=""
                            accept="image/png, image/jpg, image/jpeg"
                          />
                          <div className="text-center">
                            <button
                              variant="success"
                              type="submit"
                              size="lg"
                              className="btn m-t-5"
                            >
                              Submit
                              {show ? (
                                <span
                                  id="login_spinner"
                                  className="fa fa-spin fa-spinner text-white"
                                ></span>
                              ) : null}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                    <Form>
                      <div class="row m-auto">
                        <div className="form-group col">
                          <label>
                            First Name <span className="text-danger"> * </span>
                          </label>
                          <Field
                            type="text"
                            id="first_name"
                            className="form-control item"
                            name="first_name"
                            placeholder="Enter first name"
                            required
                          />
                        </div>
                        <div className="form-group col">
                          <label>
                            Last Name <span className="text-danger"> * </span>
                          </label>
                          <Field
                            type="text"
                            id="last_name"
                            className="form-control item"
                            name="last_name"
                            placeholder="Enter first name"
                            required
                          />
                        </div>
                        <div className="form-group col">
                          <label>Middle Name</label>
                          <Field
                            type="text"
                            id="middle_name"
                            className="form-control item"
                            name="middle_name"
                            placeholder="Enter middle name"
                          />
                        </div>
                      </div>

                      <div className="row m-auto">
                        <div className="form-group col">
                          <label>Preffered Name </label>
                          <Field
                            type="text"
                            id="preferred_name"
                            className="form-control item"
                            name="preferred_name"
                            placeholder="Enter preferred name"
                          />
                        </div>

                        <div className="form-group col">
                          <label>Employee Number </label>
                          <Field
                            type="text"
                            id="employee_number"
                            className="form-control item"
                            name="employee_number"
                            placeholder="Enter first name"
                            disabled
                          />
                        </div>

                        <div className="form-group col">
                          <label>Date Of Birth </label>
                          <Field
                            type="date"
                            id="date_of_birth"
                            className="form-control item"
                            name="date_of_birth"
                            placeholder="Enter first name"
                          />
                        </div>
                      </div>

                      <div className="row m-auto">
                        <div className="form-group col">
                          <label>
                            Date Of employment{" "}
                            <span className="text-danger"> * </span>
                          </label>

                          <DatePicker
                            selected={values.date_of_employment}
                            maxDate={new Date()}
                            showDisabledMonthNavigation
                            dateFormat="MMMM d, yyyy"
                            className="form-control"
                            name="date_of_employment"
                            onChange={(date) =>
                              setFieldValue("date_of_employment", date)
                            }
                            required
                          />
                        </div>
                        <div className="form-group col">
                          <label>
                            Gender <span className="text-danger"> * </span>
                          </label>
                          <Field
                            as="select"
                            type="text"
                            id="gender"
                            className="form-control item"
                            name="gender"
                          >
                            <option value="male">MALE</option>
                            <option value="female">FEMALE</option>
                          </Field>
                        </div>
                        <div className="form-group col">
                          <label>Mobile Number </label>
                          <Field
                            type="number"
                            id="mobile_number"
                            className="form-control item"
                            name="mobile_number"
                            placeholder="Enter Mobile Number"
                          />
                        </div>
                      </div>

                      <div className="row m-auto">
                        <div class="col-md-12">
                          <h4 style={{ color: "#000" }}>Company Details</h4>
                        </div>
                        <div class="col">
                          <div className="form-group">
                            <label>
                              Role <span className="text-danger"> * </span>
                            </label>
                            <Select
                              isMulti
                              defaultValue={values.role}
                              options={optionsss}
                              onChange={(date) => setFieldValue("role", date)}
                              isDisabled={
                                user.data.user.roles &&
                                user.data.user.roles.name !== "admin" &&
                                user.data.user.roles.name !== "human resource"
                                  ? true
                                  : false
                              }
                            />
                          </div>
                        </div>
                        <div class="col">
                          <div className="form-group">
                            <label>
                              Job Title <span className="text-danger"> * </span>
                            </label>
                            <Field
                              as="select"
                              className="form-control"
                              id="job_title"
                              name="job_title"
                              disabled={
                                user.data.user.roles &&
                                user.data.user.roles.name !== "admin" &&
                                user.data.user.roles.name !== "human resource"
                                  ? true
                                  : false
                              }
                            >
                              <option disabled>--Select Job Title--</option>

                              {jobtitles.map((jobtitle, i) => (
                                <option value={jobtitle.id} key={i}>
                                  {jobtitle.name}
                                </option>
                              ))}
                            </Field>
                          </div>
                        </div>
                        <div class="col">
                          <div className="form-group">
                            <label>
                              Employee Email{" "}
                              <span className="text-danger"> * </span>
                            </label>
                            <Field
                              type="email"
                              id="email"
                              className="form-control item"
                              name="email"
                              placeholder="Enter Employee Email"
                              required
                              disabled={
                                user.data.user.roles &&
                                user.data.user.roles.name !== "admin" &&
                                user.data.user.roles.name !== "human resource"
                                  ? true
                                  : false
                              }
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row m-auto">
                        <div class="col-md-12">
                          <h4 style={{ color: "#000" }}>Leave Summary</h4>
                        </div>
                        <div class="col-md-12 col-sm-12 col-xs-12">
                          <table class="table table-borderless">
                            <thead>
                              <tr>
                                <th scope="col">Leave type</th>
                                <th scope="col">Days remaining</th>
                              </tr>
                            </thead>
                            <tbody>
                              {leaves.map((leave, i) =>
                                remaining[i++] > 0 ? (
                                  <tr key={i}>
                                    <td>{leave.type}</td>
                                    <td>
                                      {leave.number_of_days - days[i - 1]}
                                    </td>
                                  </tr>
                                ) : null
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="row m-auto">
                        <div class="col-md-12">
                          <h4 style={{ color: "#000" }}>Financial Details</h4>
                        </div>
                        <div class="col-md-6 col-xs-12">
                          <div className="form-group">
                            <label>Account Number </label>
                            <Field
                              type="number"
                              id="account_number"
                              className="form-control item"
                              name="account_number"
                              placeholder="Enter Acount Number"
                            />
                          </div>
                        </div>
                        <div class="col-md-6 col-xs-12">
                          <div class="form-group">
                            <label>Bank</label>
                            <Field
                              as="select"
                              className="form-control"
                              id="bank_name"
                              name="bank_name"
                            >
                              <option>--Select Bank--</option>

                              {banks.map((bank, i) => (
                                <option value={bank.name} key={i}>
                                  {bank.name}
                                </option>
                              ))}
                            </Field>
                          </div>
                        </div>
                      </div>

                      <div className="row m-auto">
                        <div class="col-md-12">
                          <h4 style={{ color: "#000" }}>
                            {" "}
                            Next of Kin Details
                          </h4>
                        </div>
                        <div class="col-md-6 col-xs-12">
                          <div className="form-group">
                            <label>Fullname</label>
                            <Field
                              type="text"
                              id="full_name"
                              className="form-control item"
                              name="full_name"
                              placeholder="Enter Next of Kin Name"
                            />
                          </div>

                          <div className="form-group">
                            <label>Mobile Number</label>
                            <Field
                              type="text"
                              id="phonenumber"
                              className="form-control item"
                              name="phonenumber"
                              placeholder="Enter Phone Number"
                            />
                          </div>
                        </div>

                        <div class="col-md-6 col-xs-12">
                          <div className="form-group">
                            <label>Address</label>
                            <Field
                              type="text"
                              id="next_of_kin_address"
                              className="form-control item"
                              name="next_of_kin_address"
                              placeholder="Enter Address"
                            />
                          </div>
                          <div className="form-group">
                            <label>Relationship</label>
                            <Field
                              type="text"
                              id="relationship"
                              className="form-control item"
                              name="relationship"
                              placeholder="Enter Relationship"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="form-group m-auto row">
                        <div className="col mb-4">
                          <Link to="/dashboard/employee">
                            <button
                              type="button"
                              className="btn btn-danger btn-sm"
                            >
                              Cancel
                            </button>
                          </Link>
                        </div>
                        <div className="col-md-10 mb-4">
                          <button
                            type="submit"
                            className="btn btn-block nt-button-color-default btn-sm"
                          >
                            Update{" "}
                            {isSubmitting ? (
                              <span
                                id="login_spinner"
                                className="fa fa-spin fa-spinner"
                              ></span>
                            ) : null}
                          </button>
                        </div>
                      </div>
                    </Form>
                  </React.Fragment>
                )}
              </Formik>
            )}
          </div>
        </div>
      </PageBody>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/container/dashboard/employeemanagement/employees/edit_employe.js